import { render, staticRenderFns } from "./subTechnicalBusinessScore.vue?vue&type=template&id=fa3cb100&scoped=true"
import script from "./subTechnicalBusinessScore.vue?vue&type=script&lang=js"
export * from "./subTechnicalBusinessScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3cb100",
  null
  
)

export default component.exports